import IdeoQuoteAvatar from '@public/images/avatars/IDEO-customer-quote-avatar.png'
import MoominQuoteAvatar from '@public/images/avatars/moomin-roleff-krakstrom.png'
import VestreQuoteAvatar from '@public/images/avatars/vestre-oyvind-bjornstad.png'
import IdeoQuoteImage from '@public/images/customers/tab-quotes/tab-1/ideo.png'
import MoominQuoteImage from '@public/images/customers/tab-quotes/tab-1/moomin.png'
import VestreQuoteImage from '@public/images/customers/tab-quotes/tab-1/vestre.png'
import IdeoLogo from '@public/images/logos/ideo.png'
import MoominLogo from '@public/images/logos/moomin.png'
import VestreLogo from '@public/images/logos/vestre.png'
import { useState } from 'react'

import TwoColumnLayoutWithTabs, { TabDetails } from '@/components/TwoColumnLayoutWithTabs'

enum Customers {
    IDEO = 'IDEO',
    MOOMIN = 'Moomin',
    VESTRE = 'Vestre',
}

export type CustomerDetails = Record<Customers, TabDetails<Customers>>

const customerDetails: CustomerDetails = {
    IDEO: {
        name: Customers.IDEO,
        logo: IdeoLogo,
        description: (
            <>
                IDEO could see that transparency was critically lacking in the carbon markets, so
                they focused their search on finding high impact projects.
                <br />
                <br />
                This year, IDEO renewed their annual carbon offsetting with Lune. As part of their
                portfolio, they committed over a third of their budget into permanent carbon removal
                with UNDO Enhanced Rock Weathering.
            </>
        ),
        quoteImage: IdeoQuoteImage,
        quoteName: `Derek Robson`,
        quoteTitle: `CEO at IDEO`,
        quoteAvatar: IdeoQuoteAvatar,
        quoteText: `Lune is our preferred partner due to the emphasis on quality, real impact, and transparency –
         something that is generally lacking in the carbon markets. We are committed to credible offsetting and, going 
         forward, aim to increase our spend on permanent carbon removal projects in line with the Oxford Offsetting Principles.`,
        chips: [`climateProjects`],
        chipColor: `#FFD6B8`,
    },
    Moomin: {
        name: Customers.MOOMIN,
        logo: MoominLogo,
        description: (
            <>
                Moomin recognised that their emissions reduction efforts are a long journey and they
                wanted to do more already today.
                <br />
                <br />
                To maximise their impact, they took a contribution-led approach at set an annual
                budget of €100,000 to fund a carbon project portfolio aligned with the Oxford
                Offsetting Principles.
            </>
        ),
        quoteImage: MoominQuoteImage,
        quoteName: `Roleff Kråkström`,
        quoteTitle: `CEO at Moomin`,
        quoteAvatar: MoominQuoteAvatar,
        quoteText: (
            <>
                In parallel to our longer term emissions reduction efforts, we wanted to contribute
                to a best-in-class carbon project portfolio and support climate action globally.
                <br />
                <br />
                Lune makes it easy for us to align with the Oxford Offsetting Principles to do so!
            </>
        ),
        chips: [`climateProjects`],
        chipColor: `#E4F4F4`,
    },
    Vestre: {
        name: Customers.VESTRE,
        logo: VestreLogo,
        description: (
            <>
                After working with carbon accounting platform Variable on their overall Net Zero
                strategy, Vestre wanted to neutralise unavoidable emissions.
                <br />
                <br />
                They chose specifically to purchase only permanent carbon removal – carbon credits
                from projects which are removing existing emissions from the atmosphere and
                guaranteeing they will be safely stored for hundreds or thousands of years.
            </>
        ),
        quoteImage: VestreQuoteImage,
        quoteName: `Øyvind Bjørnstad`,
        quoteTitle: `Chief Sustainability Officer at Vestre`,
        quoteAvatar: VestreQuoteAvatar,
        quoteText: `It’s vital that businesses reduce emissions through Value Chain Interventions. Even in a Net Zero 
        future, there will be areas that are much harder or (almost) impossible to completely abate, and so carbon 
        removals are an important part of the solution for businesses, to address those areas.`,
        chips: [`climateProjects`],
        chipColor: `#BCDDEE`,
    },
}

const CustomersTab1 = () => {
    const [selectedCustomer, setSelectedCustomer] = useState<Customers>(Customers.IDEO)

    return (
        <TwoColumnLayoutWithTabs
            values={customerDetails}
            value={selectedCustomer}
            onChange={setSelectedCustomer}
        />
    )
}

export default CustomersTab1
